import serviceEncuestador from '@/services/GsEncuesta/encuestador'

export default {
  ENCUESTADOR_FIND_ALL(_, params) {
    return new Promise((resolve, reject) => {
      serviceEncuestador.findAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  ENCUESTADOr_FIND_ALL_RENIEC(_, params) {
    return new Promise((resolve, reject) => {
      serviceEncuestador.findByDni(params.dni).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  ENCUESTADOr_CREATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceEncuestador.create(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  ENCUESTADOr_CREATE_ALL(_, params) {
    return new Promise((resolve, reject) => {
      serviceEncuestador.createAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  ENCUESTADOR_UPDATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceEncuestador.update(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  ENCUESTADOR_DELETE(_, params) {
    return new Promise((resolve, reject) => {
      serviceEncuestador.delete(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
